import {
  type EdgeCenterLabel,
  type EdgeDirection,
  type EdgeId,
  type EdgeLabelValue,
  type EdgeLabels,
  type EdgeLinecapLabel,
  type EdgeLinecapLabelValue,
  isNonNullable,
} from '@ipfabric/utils';
import { type FC, type ReactNode, memo } from 'react';
import {
  PacketDetailCloseButton,
  type PacketDetailCloseEvent,
} from './PacketDetailCloseButton';

interface PacketDetailLabelsProps {
  detailId: EdgeId;
  edgeDirection: EdgeDirection;
  labels: EdgeLabels;
  onPathLookupDetailClose?: (event: PacketDetailCloseEvent) => void;
  sourceLabel: string | null;
  targetLabel: string | null;
}

const getLabelValue = (labels?: EdgeLinecapLabelValue[]): ReactNode =>
  labels
    ?.filter((item) => item.visible)
    .map(
      (
        item: EdgeLabelValue<EdgeCenterLabel | EdgeLinecapLabel>,
        index: number,
      ) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no better key
        <span key={index} className='mr-2.5'>
          {item.text}
        </span>
      ),
    );

const getProtocolLabel = (labels: ReactNode[]): ReactNode[] =>
  labels
    .filter(isNonNullable)
    .reduce((acc: ReactNode[], node: ReactNode): ReactNode[] => {
      if (acc.length === 0) {
        return [node];
      }
      acc.push(', ', node);
      return acc;
    }, []);

const BarePacketDetailLabels: FC<PacketDetailLabelsProps> = (props) => {
  return (
    <div className='flex w-full self-start p-5'>
      <div className='relative w-5'>
        {props.edgeDirection === 'bidirected' && (
          <span className='device-view-packet-detail__arrow-head-up' />
        )}
        <span className='device-view-packet-detail__arrow-body' />
        <span className='device-view-packet-detail__arrow-head-down' />
      </div>
      <div className='flex-1'>
        <div className='break-all font-bold'>
          {getProtocolLabel([
            props.sourceLabel,
            getLabelValue(props.labels.source),
          ])}
        </div>
        <div className='break-all font-bold'>
          {getProtocolLabel([
            props.targetLabel,
            getLabelValue(props.labels.target),
          ])}
        </div>
      </div>
      {props.onPathLookupDetailClose !== undefined && (
        <PacketDetailCloseButton
          detailId={props.detailId}
          onPathLookupDetailClose={props.onPathLookupDetailClose}
        />
      )}
    </div>
  );
};

export const PacketDetailLabels = memo(BarePacketDetailLabels);
